import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ProductAmount, WizumenModel, WizumenProductV2, XSellBanner } from '../../wizumen-models';
import { WizumenService } from 'projects/common/services/wizumen.service';
import { Link } from 'projects/common/components/offers/offer-card-data.model';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { Device } from 'projects/common/model/Device';

@Component({
  selector: 'wizumen-detail-dropdown',
  template: `
    <ng-container *ngIf="!isDesktopWizumenV2; else (!isTPV3Desktop) ? desktopContentIterationV2 : desktopContent">
      <eva-dropdown>
        <eva-dropdown-item (clickEvent)="handleDropdownClick()" [expand]="isActive" class="-mb">

          <span class="item-label eva-3-link" label>{{resolveDropdownTitle() | translate}}</span>
          <div content class="dropdown-content">
           <div>
            <ng-container *ngFor="let product of this.commonProducts; let i = index">
              <div class="wizumen-detail-item" [ngClass]="{'additional-items': product.order_type === 'SECONDARY'}">
                <wizumen-detail-item [product]="product"
                  [flippedIcon]="false"
                  [moduleId]="moduleId"
                  [uniqueId]="uniqueId"
                  [moduleIndex]="moduleIndex"
                  [isDesktopWizumenV2]="isDesktopWizumenV2">
                </wizumen-detail-item>
              </div>
              </ng-container>
           </div>

            <button *ngIf="link?.url && link?.title"
              class="wizumen-footer-button eva-3-btn-ghost -md wizumen-spacing"
              name="Boton Mis viajes"
              (click)="handleMyTravelsClick()">
              <i class="eva-3-icon-my-trips-ui -eva-3-icon-xsm"></i>
              <em class="btn-text wizumen-footer-link-text">
                {{link?.title}}
              </em>
            </button>

            <div class="subcontent-container">
                <incentive-xsell *ngIf="xSellBanner && !containsXSellAlert()" class="-eva-3-mt-sm"
                  [flow]="flow"
                  [locale]="locale"
                  [myTravelsHref]="myTravelsHref"
                  [moduleId]="moduleId"
                  [uniqueId]="uniqueId"
                  [moduleIndex]="moduleIndex"
                  [xSellBanner]="xSellBanner"
                  [dropdownOpened]="isActive"
                  [hasNoAssistanceOffer]="!item.travel_assistance"
                  [hasTripPlanner]="!!item.wizumen_trip_planner">
                </incentive-xsell>
                <wizumen-trip-planner *ngIf="item.wizumen_trip_planner"
                  [wizumenTripPlanner]="item.wizumen_trip_planner"
                  [moduleId]="moduleId"
                  [moduleIndex]="moduleIndex"
                  [uniqueId]="uniqueId"
                  [device]="device">
                </wizumen-trip-planner>
              <wizumen-travel-assistance *ngIf="item.travel_assistance"         
                [travelAssistance]="item.travel_assistance"
                [locale]="locale"
                [moduleId]="moduleId"
                [moduleIndex]="moduleIndex"
                [uniqueId]="uniqueId"
                [flow]="flow">
              </wizumen-travel-assistance>
            </div>
        </div>

        </eva-dropdown-item>
      </eva-dropdown>
    </ng-container>

    <ng-template #desktopContent>
      <div class="dropdown-desktop-title-container">
        <div class="dropdown-desktop-title -eva-3-bold">{{'wizumen.v2CardTitle' | translate}}</div>
        <span *ngIf="item.booking_info && isTPV3Desktop" class="wizumen-booking-status-driver-tp-v2 eva-3-driver {{layoutInfo}}">
          <span class="driver-text">{{item.booking_info.description}}</span>
        </span>
      </div>
      <div class="dropdown-content">
        <div content class="dropdown-products-desktop-container">
          <div class="products-column products-column-left">
            <ng-container *ngFor="let product of this.productListLeftColumn; let i = index">
              <div class="wizumen-detail-item-desktop">
                <wizumen-detail-item [product]="product"
                  [flippedIcon]="false"
                  [moduleId]="moduleId"
                  [uniqueId]="uniqueId"
                  [moduleIndex]="moduleIndex">
                </wizumen-detail-item>
              </div>
            </ng-container>
          </div>
          <div class="products-column products-column-right">
            <ng-container *ngFor="let product of this.productListRightColumn; let i = index">
              <div class="wizumen-detail-item-desktop" [ngClass]="{'last-item': i === this.productListRightColumn.length - 1}">
                <wizumen-detail-item [product]="product"
                  [flippedIcon]="product.order_type === 'PRIMARY'"
                  [moduleId]="moduleId"
                  [uniqueId]="uniqueId"
                  [moduleIndex]="moduleIndex">
                </wizumen-detail-item>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="xSellBanner && !hasAllProducts" class="xsell-bottom-section">
          <incentive-xsell class="-eva-3-mt-sm"
            [flow]="flow"
            [myTravelsHref]="myTravelsHref"
            [moduleId]="moduleId"
            [uniqueId]="uniqueId"
            [moduleIndex]="moduleIndex"
            [xSellBanner]="xSellBanner"
            [hasAllProducts]="false"
            [dropdownOpened]="isActive"
            [locale]="locale">
          </incentive-xsell>
        </div>
      </div>
    </ng-template>

    <ng-template #desktopContentIterationV2>
      <wizumen-detail-header
        [item]="item"
        [moduleId]="moduleId"
        [moduleIndex]="moduleIndex"
        [uniqueId]="uniqueId"
        [purchasedProductsAmount]="purchasedProductsAmount"
        [missingProductsAmount]="missingProductsAmount"
        [goToMyTravels]="goToMyTravels"
        [isTPV3Desktop]="isTPV3Desktop"
        [isDesktopWizumenV2]="isDesktopWizumenV2"
        [device]="device"
        [layoutInfo]="layoutInfo"
        [showDestinationImage]="false"
        [showProducts]="true"
        [showDateAndPassengers]="true"
        [showContent]="true"
        ></wizumen-detail-header>
        <div class="wizumen-products-cta-container">
          <div>
            <ng-container *ngFor="let product of this.commonProducts | slice: 0:3; let i = index">
              <div class="wizumen-detail-item" [ngClass]="{'additional-items': product.order_type === 'SECONDARY'}">
                <wizumen-detail-item [product]="product"
                  [flippedIcon]="false"
                  [moduleId]="moduleId"
                  [uniqueId]="uniqueId"
                  [moduleIndex]="moduleIndex"
                  [isDesktopWizumenV2]="isDesktopWizumenV2">
                </wizumen-detail-item>
              </div>
            </ng-container>
          </div>
          <button *ngIf="link?.url && link?.title"
            class="wizumen-footer-button eva-3-btn-ghost -md wizumen-spacing"
            name="Boton Mis viajes"
            (click)="handleMyTravelsClick()">
            <i class="eva-3-icon-my-trips-ui -eva-3-icon-xsm"></i>
            <em class="btn-text wizumen-footer-link-text">
              {{link?.title}}
            </em>
          </button>
        </div>
    </ng-template>
  `,
  styleUrls: ['./wizumen-detail-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenDetailDropdownComponent implements OnInit {
  @Input() item: WizumenModel;
  @Input() flow: string;
  @Input() myTravelsHref: string;
  @Input() tripId: string;
  @Input() products: WizumenProductV2[];
  @Input() xSellBanner?: XSellBanner;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() tripStatus: string;
  @Input() isActive: boolean = false;
  @Input() isDesktopWizumenV2: boolean;
  @Input() hasAllProducts: boolean;
  @Input() layoutInfo: string;
  @Input() isTPV3Desktop: boolean;
  @Input() locale: string;

  @Input() device: Device;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onToggle = new EventEmitter<boolean>();
  @Input() purchasedProductsAmount: ProductAmount[];
  @Input() missingProductsAmount: ProductAmount[];
  @Input() goToMyTravels: () => void;

  productList: WizumenProductV2[];
  commonProducts: WizumenProductV2[];

  productListLeftColumn: WizumenProductV2[] = [];
  productListRightColumn: WizumenProductV2[] = [];
  link: Link | null;

  constructor(private wizumenService: WizumenService, private upaService: UpaService) { }

  ngOnInit(): void {
    this.commonProducts = this.products.filter(product => !product.type.includes("XSELL"));
    this.link = this.item.link ?? null;

    if (this.isDesktopWizumenV2) {
      const middleIndex = Math.ceil(this.commonProducts.length / 2);

      this.productListLeftColumn = this.commonProducts.slice(0, middleIndex);
      this.productListRightColumn = this.commonProducts.slice(middleIndex);
    }
  }

  public resolveDropdownTitle(): string {
    return this.isActive ? "wizumen.cta.close" : "wizumen.cta.open";
  }

  public handleDropdownClick() {
    this.isActive = !this.isActive;
    this.onToggle.emit(this.isActive);
  }

  public containsXSellAlert() {
    return this.wizumenService.containsXSellAlert(this.xSellBanner);
  }

  handleMyTravelsClick(): void {
    this.trackMyTravelsClick();

    window.open(this.link?.url, '_blank');
  }

  public trackMyTravelsClick() {
    this.upaService.trackClickTopic({
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.WIZUMEN,
      label: 'MV',
      href: this.link?.url,
      uniqueId: this.uniqueId
    })
  }
}
